import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { ArbolMenu } from '../../models/arbol-menu';
import { NodeType } from '../../models/node-type';
import { NodoArbolMenu } from '../../models/nodo-arbol-menu';
import { MenuArbolService } from '../../services/menu-arbol.service';
import { environment } from 'src/environments/environment';
import { ConciergeService } from '../../../../services/concierge.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';

@Component({
  selector: 'app-menu-arbol',
  templateUrl: './menu-arbol.component.html',
  styleUrls: ['./menu-arbol.component.scss']
})
export class MenuArbolComponent implements OnInit, OnDestroy{


  @Input() public ctx: Contexto;
  @Output() renderMenuArbolEmitter = new EventEmitter<Object>();

  cargandoDatos: boolean;
  arbolMenu: ArbolMenu;
  currentFAQ: NodoArbolMenu[];
  faq: any;
  currentFather: NodoArbolMenu; //o currentRoute (la ruta hasta el nodo padre)
  currentGrandparent: NodoArbolMenu; 
  displayedNodes: NodoArbolMenu[]; //Los nodos que se mostrarán en en menú en el estado actual del programa.
  answerDisplayed: boolean;
  answerNode: NodoArbolMenu;
  temaActual: string;

  testVarToDisplayUrls: any;
  visiblePath: string;
  maxPathLength: number = 100;
  subscriptionConcierge: Subscription;
  displayFormEmpresa:boolean;
  displayForm: boolean;
  habilitado: boolean;
  cantidadNodos: number;
  numberOfSiblingsArr: number[];
  numberOfSiblingsArrCreation: number[];  
  
  mostrarDiv = true;
  miValorVariable: string = 'Raiz';
  miValorVariablePadre: string = '';
  
  constructor(private localstorage: LocalStorageService,
    public conciergeService: ConciergeService,
    private menuArbolService: MenuArbolService) {
    this.answerDisplayed = false;
    this.displayFormEmpresa = false;
    this.displayForm = true;
    this.temaActual = "Declaración Nominada"
  }

  ngOnInit() {
    this.loadArbolMenu(this.ctx.idMenu);

  }

  loadArbolMenu(idMenu) {
    this.cargandoDatos = true;
    this.menuArbolService.loadMenuArbolTree(idMenu).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let jsonTree = data.content;
        this.habilitado = jsonTree.habilitado;
        let root = new NodoArbolMenu("ROOT", data.content.idMenu, "Raiz", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, jsonTree.faqs,undefined)
        let arbol = new ArbolMenu(root);
        this.arbolMenu = arbol.buildTree(jsonTree)
        this.currentFather = this.arbolMenu.root;
        this.currentGrandparent = undefined;
        this.reloadTree();
        this.faq = jsonTree.menuFAQ;
        this.loadFAQ();
        this.updateVisiblePath();
        this.miValorVariable = this.currentFather.name!=="Raiz"?this.currentFather.name : 'Raiz';
        this.miValorVariablePadre = this.currentFather.name!=="Raiz"?this.currentGrandparent.name: '';
        // Si tiene definido empresa verifica que venga instanciada. Si no viene no muestra el formulario
        if (this.ctx.formElements.datosEmpresa) {
          this.displayFormEmpresa = (this.ctx.datosEmpresa.nroEmpresa !== undefined);
        } else {
          this.displayFormEmpresa = true;
        }
        this.cargandoDatos = false;
      } else {
       // alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        //alert(error);
        this.cargandoDatos = false;
      })
  }

  returnToStart() {
    this.currentFather = this.arbolMenu.root;
    this.currentGrandparent = undefined;
    this.reloadTree();
    this.clearAnswerDisplayed();
    this.loadFAQ();
    this.updateVisiblePath();
    this.miValorVariable = 'Raiz';    
    this.miValorVariablePadre = '';
  }

  seleccionarNodo(event) {
    for (let nodo of this.displayedNodes) {
      if (nodo.id == event) {
        if (nodo.childs.length>0){
          this.currentFather = nodo;
          this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
          this.reloadTree();
          this.loadFAQ();
          this.updateVisiblePath();
          this.miValorVariable = this.currentFather.name;
          this.miValorVariablePadre = this.currentFather.name!=="Raiz"?this.currentGrandparent.name: '';
        }
      }
    }
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async emitRenderMenuArbol(event)  {
    this.renderMenuArbolEmitter.emit(event);
   /** await this.sleep(1000);
    let idMenuNuevo = this.localstorage.getIdMenuAccion();
    let handlerAccion = this.localstorage.getHandlerAccionType();
    if(idMenuNuevo && idMenuNuevo != undefined && idMenuNuevo != this.ctx.idMenu && handlerAccion === 'menuArbol') {
      this.loadArbolMenu(idMenuNuevo);
    }**/
  }


  loadFAQ() {
    this.currentFAQ = []
    for (let faq of this.currentFather.faqs) {
      let node = new NodoArbolMenu(
        undefined,
        undefined,
        faq.consulta,
        NodeType.FAQ,
        undefined,
        undefined,
        faq.respuesta,
        undefined,
        faq.codigoTemaDestinatario
      );
      this.currentFAQ.push(node);
    }

  }

  reloadTree() {
    this.displayedNodes = this.sortNodes(this.currentFather.childs);
    this.displayForm = (this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario;
  }

  displayAnswer(obj) {
    this.answerNode = obj;
    this.displayForm = (this.answerNode.areaCode !== undefined) && (this.answerNode.areaCode !== '') && this.answerNode.conDestinatario;
    // this.generateHTMLLinks(this.answerNode.answer);
    this.answerDisplayed = true;
    this.miValorVariable = this.answerNode.name;
    this.miValorVariablePadre = this.currentFather.name!=="Raiz"?this.currentFather.name: '';
  }

  clearAnswerDisplayed() {
    this.answerNode = undefined;
    this.answerDisplayed = false;
    //this.displayForm = this.currentFather &&  ((this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario);
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name!=="Raiz"?this.currentGrandparent.name: '';
    this.displayForm = (this.currentFather.areaCode !== undefined) && (this.currentFather.areaCode !== '') && this.currentFather.conDestinatario;
  }

  sortNodes(nodes: NodoArbolMenu[]){
    let sorted = nodes.sort((a,b)=>{
      return a.order-b.order;
    })
    return sorted;
  }

  cargarConsulta() {
    // Antes de cargar el formulario se guarda el historico de navegacion (desde donde partio la llamada al formulario)
    this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
    this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
    this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
    this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;

    if(this.answerNode && (this.answerNode.type === 'RESPUESTA' || this.answerNode.type ==='FAQ')){
      //this.ctx.etiquetaTema = this.answerNode.name;
      this.ctx.etiquetaNodoArbol = this.answerNode.id;
      this.ctx.etiquetaNodoArbol = this.answerNode.name;

       
      //this.renderMenuArbolEmitter.emit({idServicio: environment.formAsistencia, codigoTema:this.answerNode.areaCode});
      this.renderMenuArbolEmitter.emit({idServicio: this.ctx.idServicio, codAsistente: this.ctx.idFormAsociado, codigoTema:this.answerNode.areaCode});
    }else{
      // Se asigna el nombre del nodo a la etiqueta par que despliegue el formulario de consulta
      //this.ctx.etiquetaTema = this.currentFather.name;
      this.ctx.codigoNodoArbol = this.currentFather.id;
      this.ctx.etiquetaNodoArbol = this.currentFather.name;

      //this.renderMenuArbolEmitter.emit({idServicio: environment.formAsistencia, codigoTema:this.currentFather.areaCode})
      this.renderMenuArbolEmitter.emit({idServicio: this.ctx.idServicio, codAsistente: this.ctx.idFormAsociado, codigoTema:this.currentFather.areaCode})
    }
   }

  loadParent() {
    //Crear método en el árbol para hacer búsqueda.
    this.currentFather = this.arbolMenu.search(this.currentFather.parentId);
    this.currentGrandparent = this.arbolMenu.search(this.currentFather.parentId);
    this.reloadTree();
    this.clearAnswerDisplayed();
    this.loadFAQ();
    this.updateVisiblePath();
    this.miValorVariable = this.currentFather.name;
    this.miValorVariablePadre = this.currentFather.name!=="Raiz"?this.currentGrandparent.name: '';
  }

  //Slicing del path para que no quede muy largo
  updateVisiblePath() {
    if (this.currentFather.id === "ROOT") {
      return;
    }
    if (this.currentFather.path.length > this.maxPathLength) {
      let split = this.currentFather.path.split(">")
      let i = split.length - 1;
      let aux = "";
      while (i > 0) {
        if (aux.length + split[i].length > this.maxPathLength) {
          break;
        }
        if (i !== split.length - 1) {
          aux = split[i] + ">" + aux;
        }
        else { aux = split[i] }
        i--;
      }
      aux = aux === "" ? split[i] : aux;
      this.visiblePath = "... " + aux;
    }
    else {
      this.visiblePath = this.currentFather.path;
    }

  }

  updateGrandparent(){

  }
  
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }

  ngOnDestroy(): void {
  }
}
